import React, { FunctionComponent } from "react"
import { Button, Modal, OverlayTrigger, Table } from "react-bootstrap"
import HRRViewReportTable from "./HRRViewReportTable/HRRViewReportTable"
import HRRService from "../utils/HRRService"
import { CSVLink } from "react-csv"
import snackBar from "src/utilities/snackBar/SnackBar"
import "./HRRViewReport.css"


const HRRViewReport: FunctionComponent<{}> = () => {

    const { manageState, nameReport, HRRServiceTooltip, state } = HRRService
    const { employeeReport, selectedReport } = state
    //@ts-ignore
    const fileName = nameReport(selectedReport)

    return (
        <div className="HRRViewReport">
            <Modal
                id="hrr-view-report-modal"
                show={true}
                backdrop="static"
                keyboard={true}
                centered={true}
                size="xl"
            >
                <Modal.Header>
                    <div className="HRRViewReportModalHeader">
                        {fileName}
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="HRRViewReportModalBody">
                        <HRRViewReportTable />
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="HRRViewReportModalFooter">
                        <div className="HRRViewReportModalFooterLeft">
                            <Button variant="secondary" onClick={() => manageState([{ key: "viewReport", value: false }])}>Back</Button>
                        </div>
                        <div className="HRRViewReportModalFooterRight">
                            <OverlayTrigger placement="left" overlay={HRRServiceTooltip("Download report")}>
                                <CSVLink
                                    data={employeeReport}
                                    filename={nameReport()}
                                >
                                    <span className="material-icons" onClick={() => {
                                        snackBar({ type: "primary", text: `downloaded ${fileName}`, timeout: 3000 })
                                    }}>download</span>
                                </CSVLink>
                            </OverlayTrigger>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default HRRViewReport